import { UsersProvider } from "contexts/UsersContext";
import { ProjectsPage } from "pages/Projects/ProjectsPage";
import { Redirect, Route, Switch } from "react-router-dom";

export const ProjectsRoutes = (): JSX.Element => {
  return (
    <Switch>
      <Route exact path="/pages/projects/:id?">
        <UsersProvider>
          <ProjectsPage />
        </UsersProvider>
      </Route>

      {/* Redirect to the closest exact path above when an incorrect url is entered*/}
      <Redirect to="/pages/projects" from="/pages/projects" />
      <Redirect to="/pages" />
    </Switch>
  );
};
